import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { Button } from './ui/button';

const KEY = 'aeroops_cookie_notice_v1';

export const CookieBanner = () => {
    const [seen, setSeen] = useState(() => localStorage.getItem(KEY) === '1');
    if (seen) return null;
    return (
        <div className="fixed bottom-4 left-4 right-4 md:left-auto md:max-w-md z-[60] rounded-xl border border-border bg-card/95 backdrop-blur-xl p-4 shadow-2xl" data-testid="cookie-banner">
            <div className="flex gap-3">
                <Cookie className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" />
                <div className="text-sm">
                    <p className="mb-3 text-muted-foreground">Usamos solo almacenamiento técnico para mantener tu sesión y tus preferencias. Nada de publicidad ni seguimiento. <Link to="/cookies" className="text-primary underline" data-testid="cookie-banner-link">Más información</Link></p>
                    <Button size="sm" onClick={() => { localStorage.setItem(KEY, '1'); setSeen(true); }} data-testid="cookie-banner-accept">Entendido</Button>
                </div>
            </div>
        </div>
    );
};
